import components from './components'
import loginPage from './login_page'
import register from './register'
import email from './email/index.js'
import registerWaiting from './register_waiting'
import phoneRegister from './phone/register'
import hr_bind from './hr_bind'

import resetPassword from './reset_password'
export default {
  components,
  phoneRegister,
  loginPage,
  register,
  email,
  registerWaiting,
  resetPassword,
  hr_bind
}
